import { createSelector } from '@reduxjs/toolkit';
import { selectBuildingCranageTypesType } from 'shared/selectors/jsonQuery';
import { EBuildingCraneType } from '../../../../packages/api-models/common/json_query';

const OPTIONS = [
  { label: 'Кран-балка', value: EBuildingCraneType.Beam },
  { label: 'Козловой кран', value: EBuildingCraneType.Goat },
  { label: 'Мостовой кран', value: EBuildingCraneType.Overhead },
  { label: 'Ж/д кран', value: EBuildingCraneType.Railway },
];

export const selectBuildingCranageTypesTypeFilter = createSelector(selectBuildingCranageTypesType, value => ({
  label: 'Кран',
  options: OPTIONS,
  value: value && value.length > 0 ? value : [null],
}));
